import { Component, OnInit } from '@angular/core';
import { ICurrentUserViewModel } from '@services/cleanfill-api/cleanfill-api.generated';
import { AuthService } from '@services/core/auth.service';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'user-menu',
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.scss']
})
export class UserMenuComponent implements OnInit {
  user: ICurrentUserViewModel;
  constructor(private loginService: AuthService) {}

  ngOnInit(): void {
    this.loginService.activeUser$.pipe(filter(Boolean)).subscribe((user: ICurrentUserViewModel) => (this.user = user));
  }

  onLogout() {
    this.loginService.logout();
  }
}
